import { defineStore } from 'pinia'
import apiCall from '$/plugins/axios'

export const useStore = defineStore('', {
  state: () => ({
    sending: false,
    loading: true,
    ready: false,
    systemConfigs: {},
    articles: [],
  }),

  actions: {
    setSending(status = true) {
      this.sending = status
    },
    setLoading(status = true) {
      this.loading = status
    },

    fetchSystemConfigs() {
      return new Promise((resolve) => {
        apiCall.get('/system_configs').then((res) => {
          this.systemConfigs = res.data
          resolve()
        })
      })
    },

    fetchArticles() {
      return new Promise((resolve) => {
        apiCall.get('/articles').then((res) => {
          this.articles = res.data
          resolve()
        })
      })
    },

    createContact(payload) {
      return new Promise((resolve, reject) => {
        apiCall
          .post('/contacts', { contact_form: payload })
          .then((res) => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },

  getters: {
    article: (state) => (slug) => state.articles.find((i) => i.slug === slug),
  },
})
